import * as React from "react";
import Checkbox from "@mui/material/Checkbox";
import { useTranslation } from "react-i18next";
import { default as DataGrid } from "../../../components/LocalizedDataGrid";
import { FormControlLabel } from "@mui/material";




export default function HvacSelector(props) {
    const { hvacPoints, selectedHvacPoints, setSelectedHvacPoints } = props;

    const { t } = useTranslation();

    const selectedSet = new Set(selectedHvacPoints);

    const handleSelectHvac = (url) => {
        setSelectedHvacPoints(
            (old) => [...old, url]
        )
    }

    const handleUnselectHvac = (url) => {
        setSelectedHvacPoints(
            (old) => old.filter((item) => item !== url)
        )
    }

    const handleSelectAll = () => {
        const allUrls = hvacPoints.map((point) => point.url);
        setSelectedHvacPoints(allUrls);
    }

    const handleUnselectAll = () => {
        setSelectedHvacPoints([]);
    }

    const columns = [
        {
            field: "selected",
            headerName: t("Apply to?"),
            minWidth: 180,
            valueGetter: (params) => selectedSet.has(params.row.url),
            renderCell: (params) => {
                return (
                    <Checkbox
                        checked={params.value}
                        onChange={(event) => {
                            if (!params.value) handleSelectHvac(params.id);
                            else handleUnselectHvac(params.id);
                        }}
                    />
                );
            },
            renderHeader: () => {
                return (
                    <FormControlLabel
                        control={
                            <Checkbox
                                onClick={(event) => { event.stopPropagation() }}
                                onChange={(event) => {
                                    event.stopPropagation();
                                    if (event.target.checked) handleSelectAll();
                                    else handleUnselectAll();
                                }}
                                checked={selectedHvacPoints.length === hvacPoints.length && hvacPoints.length > 0}
                            />
                        }
                        label={t("Apply to")}
                    />);
            }
        },

        { field: "location", headerName: t("Location"), flex: 1, minWidth: 200 },
        { field: "name", headerName: t("Name"), flex: 1, minWidth: 180 },
    ];

    return (
        <DataGrid
            rows={hvacPoints}
            columns={columns}
            getRowId={(row) => row.url}
            disableSelectionOnClick={true}
        />
    );
}